import { PRODUCT_NAME } from "@amtana/i18n/catalog";

import type { UseCaseWords } from "./use-case-page.ts";

// /use-cases/competitor-followers, in English. The product reads an account's followers and its
// following, and no other source (D1151). On a credit it says what the Terms say (D1153).
export const COMPETITOR_FOLLOWERS_WORDS_EN: UseCaseWords = {
  linkLabel: "Competitor followers",
  title: "Leads from competitor followers",
  description: `Find leads from competitor followers: ${PRODUCT_NAME} reads the public profiles among an account's followers, and you filter and export the list.`,
  keyphrase: "leads from competitor followers",
  heroTitle: "Turn a competitor's followers into leads",
  lede: `Name an account your buyers follow. ${PRODUCT_NAME} reads its followers and leaves the public profiles on a list you can filter and export.`,
  steps: [
    {
      eyebrow: "1 · Name",
      title: "Pick the account",
      description: "One your buyers already follow.",
    },
    {
      eyebrow: "2 · Read",
      title: `${PRODUCT_NAME} reads its followers`,
      description: "Public profiles only. 1 credit reads 1 public profile.",
    },
    {
      eyebrow: "3 · Use",
      title: "Filter and export",
      description: "Filter by type or contact, then download a CSV.",
    },
  ],
  sample: [
    {
      name: "Sample Bakery",
      username: "sample.bakery",
      type: "business",
      email: "he•••@example.com",
      phone: "+00 ••• ••• 000",
    },
    {
      name: "Sample Studio",
      username: "sample.studio",
      type: "business",
      email: "in•••@example.com",
      phone: null,
    },
    {
      name: "Sample Person",
      username: "sample.person",
      type: "personal",
      email: null,
      phone: null,
    },
    {
      name: "Sample Clinic",
      username: "sample.clinic",
      type: "business",
      email: null,
      phone: "+00 ••• ••• 000",
    },
  ],
  get: [
    "A list of the public profiles among the account's followers.",
    "Each profile's name, username and type, business or personal.",
    "Any email or phone the profile shows in public.",
    "Filters by type and contact, and a CSV export.",
  ],
  limit: "Private accounts are not read, and not every public profile shows a contact.",
  questions: [
    {
      question: "Does it read private accounts?",
      answer: `No. ${PRODUCT_NAME} reads public profiles only.`,
    },
    {
      question: "Will every profile have an email?",
      answer: "No. Some public profiles show an email or a phone, and some show neither.",
    },
    {
      question: "What does a credit buy?",
      answer: "1 credit reads 1 public profile, with or without a contact. Private accounts are not read.",
    },
    {
      question: "Where do the contacts come from?",
      answer: "From what each account publishes on its own public profile.",
    },
    {
      question: "Can it read the accounts someone follows?",
      answer: "Yes. A scan reads an account's followers or its following.",
    },
  ],
  ctaTitle: "Start with one account",
  ctaDescription: "Your first analysis runs on free credits.",
};
